const AuthHeader = () => {
  return (
    <div className=''>
        <img src='/icons/BigLogo.png' alt='Logo' className='xl:w-[250px] w-[150px] xl:h-[70px]'/>
    </div>
  )
}

export default AuthHeader